export const  orderlist=[
   {
      id:1,
      number:"1",
      hash:"#456861",
      status:"Moving",
      Operator:"Ossim keter",
      date:"16 August",
      address:"Green Bay, Wisconsin, London",
      price:"$450.00",
   },
   {
      id:2,
      number:"2",
      hash:"#846953",
      status:"Moving",
      Operator:"Ossim keter",
      date:"21 September",
      address:"Summerlin, Nevada, United kingdom",
      price:"$136.00",


   },
   {
      id:3,
      number:"3",
      hash:"#197568",
      status:"Cancel",
      Operator:"Fran loain",
      date:"06 March",
      address:"Atlantic City, New Jersey, UK",
      price:"$624.00",

   },
   {
      id:4,
      number:"4",
      hash:"#647953",
      status:"Pending",
      Operator:"Loften Horen",
      date:"12 February",
      address:"Fort Worth, Soun Di, Texas, USA",
      price:"$48.00",

   },
   {
      id:5,
      number:"5",
      hash:"#447495",
      status:"Moving",
      Operator:"Loie fenter",
      date:"12 February",
      address:"Green Bay, Wisconsin, London",
      price:"$258.00",

   },


]
